module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The writing of a book is not just a solo activity, although at times it can feel like it. The writing and research of this book has taken over three years’ almost full time work, during which time the support of Andy Mason, innumerable cups of coffee, road trips to various archives and record offices, and a shoulder to cry on has kept me going on the way. I should also like to thank the railway staff and all the volunteers at the Science & Industry Museum, Manchester, past and present, for their friendship, encouragement and technical help. In particular Peter Brown (volunteer driver), Professor Bev Pardoe (retired volunteer driver), Paul Dore (retired volunteer driver), and Matthew Jackson (former Railway Officer). Thanks too to the Liverpool & Manchester Railway Trust for the use of illustrations in their collection, and for their encouragement. Thanks are also due to Stephen Weston for his editing, and to MRFS for his proof-reading and help knocking the final manuscript into shape. Finally to Richard Gibbon OBE, former Head of Engineering at the National Railway Museum for peer-review of the text and to Colonel Steve Davies MBE for his foreword.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c65c246","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Acknowledgements.vue
// module id = 69
// module chunks = 0